import { moimAPI } from ".";

export async function getProfileBlockit(
  groupId: string,
  userId: string,
  viewType: "show" | "preview",
) {
  return (
    await moimAPI.request<Promise<Moim.IListResponse<Moim.Blockit.Blocks>>>({
      method: "GET",
      params: { viewType, version: "v4" },
      url: `/groups/${groupId}/users/${userId}`,
    })
  ).data;
}
